import { render, staticRenderFns } from "./bannerCategory.vue?vue&type=template&id=630cd929&scoped=true&"
import script from "./bannerCategory.vue?vue&type=script&lang=js&"
export * from "./bannerCategory.vue?vue&type=script&lang=js&"
import style0 from "./bannerCategory.vue?vue&type=style&index=0&id=630cd929&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cd929",
  null
  
)

export default component.exports